<div class="price" [class.discounted]="discounted">
{{ quantity * (modprice_old ? modprice_old : modprice) | currency:priceCurrency }}&nbsp;
</div>	
<div class="price-old" [class.discounted]="discounted" *ngIf="discounted">
	<span class="info" i18n>Cena początkowa:</span>
	<span class="normal"> {{ quantity * modprice | currency:priceCurrency }}</span>
	<span class="discount"> -{{ 100 - (modprice_old / modprice * 100) | number:'1.0-0' }}% </span>
</div>